import {db} from "./config";
import {onValue, ref, set, remove} from "firebase/database"
import {useState} from "react";
import {OnlyStringProps} from "../types";

export const useItemValue = (path: string): OnlyStringProps => {
    const [value, setValue] = useState<OnlyStringProps>({});

    const query = ref(db, path);
    onValue(query, (snapshot) => {
        const val = snapshot.val() || {};
        if (Object.keys(val).length !== Object.keys(value).length) {
            setValue(val);
        }
    });

    return value;
};

export const setItem = (path: string, value: string | object): Promise<void> => {
    return set(ref(db, path), value);
};

export const deleteItem = (path: string): Promise<void> => {
    return remove(ref(db, path));
};
